/** @format */

import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import menuService from "../Services/menuService";
import { PlanService } from "../Services";
import { Storage } from "../Storage/Storage";
import { RiFileList3Line,
  RiDashboardLine,
  RiMastercardLine,
  RiCreativeCommonsZeroLine,
  RiGiftLine,
  RiAdminLine,
  RiGalleryLine,
  RiBloggerLine,
  RiQuestionAnswerLine
} from "react-icons/ri";
import { TbReceiptTax } from "react-icons/tb";
import { GrLocation } from "react-icons/gr";
import { MdOutlineCategory } from "react-icons/md";
// import helperFunction from "../Function/helperFunction";
// import { access as accessObj } from "../Container/Subadmin/accessObj";

const sidebarmenu = [
  {
    item_id: "1",
    menu_title: "Dashboard",
    menu_url: "/dashboard",
    menu_name: "dashboard",
    menu_icone: () => <RiDashboardLine />,
    sub_menu: [],
  },
  {
    item_id: "menu_management_1",
    menu_title: "Menu Management",
    menu_url: "/menu-list",
    menu_name: "all",
    menu_icone: () => <RiFileList3Line />,
    sub_menu: [],
  },
  {
    item_id: "rate_checker_1",
    menu_title: "Rate Checker",
    menu_url: "/rate-checker",
    menu_name: "rate_checker",
    menu_icone: () => <RiDashboardLine />,
    sub_menu: [],
  },
  {
    item_id: "c1",
    menu_url: "/support-tickets",
    menu_title: "Support Tickets",
    menu_icone: () => <RiQuestionAnswerLine />,
    menu_name: true,
    sub_menu: [],
  },
  {
    item_id: "999",
    menu_title: "My Bookings",
    menu_url: "/job-list",
    menu_name: "my_bookings",
    menu_icone: () => <RiBloggerLine />,
    sub_menu: [],
  },
  {
    item_id: "998",
    menu_title: "Quotations",
    menu_url: "/quotations",
    menu_name: "quotations",
    menu_icone: () => <RiBloggerLine />,
    sub_menu: [],
  },
  {
    item_id: "plan_mgmt",
    menu_title: "Plan Management",
    menu_url: "/plan-list",
    menu_name: "plan_management",
    menu_icone: () => <RiBloggerLine />,
    sub_menu: [],
  },
  {
    item_id: "2",
    menu_title: "Master",
    menu_url: "",
    menu_name: "master",
    menu_icone: () => <RiMastercardLine />,
    sub_menu: [
      {
        item_id: "21",
        menu_title: "Rate Master",
        menu_url: "",
        menu_name: "rate_master",
        sub_menu: [
          {
            item_id: "211",

            menu_url: "/storage-list",
            menu_title: "Storage",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "212",

            menu_url: "/profit-margin-list",
            menu_title: "Profit Master",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "213",

            menu_url: "/package-master",
            menu_title: "Package",
            menu_name: true,
            sub_menu: [],
          },

          {
            item_id: "214",
            menu_url: "/insurance", // 6
            menu_title: "Insurance ",
            menu_name: true,
            sub_menu: [],
          },

          {
            item_id: "215",
            menu_url: "/courier-additional-charges", // 6
            menu_title: "Courier Additional Charges ",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "216",
            menu_url: "/courier-rates", // 6
            menu_title: "Courier Rates ",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21F",
            menu_url: "/courier-mode-charges",
            menu_title: "Courier Mode Charges",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21G",
            menu_url: "/land-mode-charges",
            menu_title: "Land Mode Charges",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "217",
            menu_url: "/error-margin", // 6
            menu_title: "Error Margin",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "218",
            menu_title: "Freight Rates",
            menu_url: "",
            menu_name: true,
            menu_icone: () => <RiMastercardLine />,
            sub_menu: [
              {
                menu_url: "/air-freight-rate-list",
                menu_title: "Air",
                sub_menu: [],
              },
              {
                menu_url: "/air-consolidation-rate-list",
                menu_title: "Air Consolidation",
                sub_menu: [],
              },
              {
                menu_url: "/sea-freight-rate-list",
                menu_title: "Sea",
                sub_menu: [],
              },
              {
                menu_url: "/sea-consolidation-rate-list",
                menu_title: "Sea Consolidation",
                sub_menu: [],
              },

              {
                menu_url: "/courier-freight-rate-list",
                menu_title: "Courier",
                sub_menu: [],
              },
              {
                menu_url: "/land-express",
                menu_title: "Land Express",
                sub_menu: [],
              },
              {
                menu_url: "/land-consolidation",
                menu_title: "Land Consolidation",
                sub_menu: [],
              },
              // {
              // 	menu_url: "",
              // 	menu_title: "Cross Border (coming soon) ",
              // 	sub_menu: [],
              // },
            ],
          },
          {
            item_id: "219",
            menu_title: "Origin Charges",
            menu_url: "",
            menu_name: true,
            menu_icone: () => <RiMastercardLine />,
            sub_menu: [
              {
                menu_url: "/domestic-tariff-list",
                menu_title: "Domestic tariff 1",
                menu_name: true,
                sub_menu: [],
              },
              // {
              // 	menu_url: "",
              // 	menu_title: "Domestic tariff 2 (coming soon)",
              // 	sub_menu: [],
              // },
              {
                menu_url: "/air-origin-charge-list",
                menu_title: "Air ",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/air-consolidation-origin-charge-list",
                menu_title: "Air Consolidation",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/sea-origin-charge-list",
                menu_title: "Sea ",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/sea-consolidation-origin-charge-list",
                menu_title: "Sea Consolidation",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/courier-origin-charge-list",
                menu_title: "Courier",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/cross-border-origin-charge-list",
                menu_title: "Cross border ",
                menu_name: true,
                sub_menu: [],
              },
            ],
          },
          {
            item_id: "220",
            menu_title: "Destination Charges",
            menu_url: "",
            menu_name: true,
            menu_icone: () => <RiMastercardLine />,
            sub_menu: [
              {
                menu_url: "/inland-destination-charge-list",
                menu_title: "Inland",
                menu_name: true,
                sub_menu: [],
              },

              {
                menu_url: "/air-destination-charge-list",
                menu_title: "Air",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/air-destination-consolidation-charge-list",
                menu_title: "Air Consolidation",
                menu_name: true,
                sub_menu: [],
              },

              {
                menu_url: "/sea-destination-charge-list",
                menu_title: "Sea",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/sea-destination-consolidation-charge-list",
                menu_title: "Sea Consolidation",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/cross-border-list",
                menu_title: "Cross Border",
                menu_name: true,
                sub_menu: [],
              },
            ],
          },
          {
            item_id: "21A",
            menu_url: "/attribute-additional-fees", // 6
            menu_title: "Attribute Additional Fees",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21B",
            menu_url: "/hs-code-additional-fees", // 6
            menu_title: "HS Code Additional Fees",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21C",
            menu_url: "/hs-code-remarks", // 6
            menu_title: "HS Code Remarks",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21D",
            menu_url: "/hs-code-duty-taxes", // 6
            menu_title: "HS Code Duty Taxes",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "21E",
            menu_url: "/marketplace-additional-charges", // 6
            menu_title: "Marketplace Additional Charges",
            menu_name: true,
            sub_menu: [],
          },
        ],
      },
      {
        item_id: "22",
        menu_title: "Profile Master",
        menu_url: "",
        menu_name: "profile_master",
        sub_menu: [
          {
            item_id: "221",
            menu_url: "/customer ",
            menu_title: "Customer",
            menu_name: true,
            sub_menu: [
              {
                menu_url: "/individual-list",
                menu_title: "Individual/Commercials",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/retailer-list",
                menu_title: "Retailer/Corporates/Marketplace",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/saas-retailer-list",
                menu_title: "SaaS Retailer Approvals",
                menu_name: true,
                sub_menu: [],
              },
              {
                menu_url: "/rate-approval-list",
                menu_title: "Rate Approvals",
                menu_name: true,
                sub_menu: [],
              },
              // {
              //     menu_url: '/store-list',
              //     menu_title: 'Store',
              //     sub_menu: []
              // },
              // {
              // 	menu_url: "/corporates-list",
              // 	menu_title: "Corporates",
              // 	sub_menu: [],
              // },
              // {
              // 	menu_url: "/commercials-list",
              // 	menu_title: "Commercials",
              // 	sub_menu: [],
              // },
            ],

          },
          {
            item_id: "222",
            menu_url: "/warehouse-list", // 6
            menu_title: "Warehouse",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "223",
            menu_url: "/product-list", // 6
            menu_title: "Product",
            menu_name: true,
            sub_menu: [],
          },
          {
            item_id: "224",
            menu_url: "/vendor-list",
            menu_title: "Vendors",
            menu_name: true,
            sub_menu: [],
          },
          // {
          //   item_id: "225",
          //   menu_url: "/courier-partner-list",
          //   menu_title: "Courier Partners",
          //   menu_name: true,
          //   sub_menu: [],
          // },
          // {
          //   item_id: 225,
          //   menu_url: "/sales-and-customer-service-list",
          //   menu_title: "Sales / Customer Service",
          //   menu_name: true,
          //   sub_menu: [],
          // },
        ],
      },
    ],
  },
  {
    item_id: "3",
    menu_title: "Add Location",
    menu_url: "",
    menu_name: "add_locations",
    menu_icone: () => <GrLocation />,
    sub_menu: [
      {
        item_id: "31",
        menu_url: "/country-list",
        menu_title: "Country",
        sub_menu: [],
        menu_name: true,
      },
      {
        item_id: "32",
        menu_url: "/port-list",
        menu_title: "Port",
        sub_menu: [],
        menu_name: true,
      },
      {
        item_id: "33",
        menu_url: "/courier-country-service",
        menu_title: "Courier Country Service",
        sub_menu: [],
        menu_name: true,
      },
    ],
  },
  {
    item_id: "5",
    menu_title: "Promo",
    menu_url: "/promo-list",
    menu_name: "promo",
    menu_icone: () => <RiGiftLine />,
    sub_menu: [],
  },
  {
    item_id: "7",
    menu_title: "Duties And Taxes",
    menu_url: "/duty-and-tax-list",
    menu_name: "duty_and_tax",
    menu_icone: () => <TbReceiptTax />,
    sub_menu: [],
  },
  {
    item_id: "7a",
    menu_title: "HS Code Requests",
    menu_url: "/hs-code-requests-list",
    menu_name: "duty_and_tax",
    menu_icone: () => <RiQuestionAnswerLine />,
    sub_menu: [],
  },
  {
    item_id: "4",
    menu_title: "Operation",
    menu_url: "",
    menu_name: "operation",
    menu_icone: () => <RiCreativeCommonsZeroLine />,
    sub_menu: [
      {
        item_id: "41",
        menu_url: "",
        menu_title: "CRM",
        menu_name: "crm",
        sub_menu: [
          {
            item_id: "411",
            menu_url: "/enquiry-management-c-r-m-list",
            menu_title: "Enquiry Management",
            menu_name: "enquiry",
            sub_menu: [],
          },
          {
            item_id: "412",
            menu_url: "/job-list",
            menu_title: "Active Jobs",
            menu_name: "jobs_bookings",
            sub_menu: [],
          },
          {
            item_id: "413",
            menu_url: "/closed-job-list",
            menu_title: "Closed Jobs",
            menu_name: "jobs_closed",
            sub_menu: [],
          },
          {
            item_id: "415",
            menu_url: "/deleted-job-list",
            menu_title: "Deleted Jobs",
            menu_name: "jobs_deleted",
            sub_menu: [],
          },

          {
            item_id: "414",
            menu_url: "/follow-up",
            menu_title: "Follow Up",
            menu_name: "follow_up",
            sub_menu: [],
          },

          {
            item_id: "416",
            menu_url: "/outstanding-jobs",
            menu_title: "Outstanding Jobs",
            menu_name: "outstanding_jobs",
            sub_menu: [],
          },
        ],
      },
      {
        item_id: "42",
        menu_url: "/quickbook-auth",
        menu_title: "Accounting",
        menu_name: "accounts",
        sub_menu: [
          {
            item_id: "421",
            // menu_url: "/",
            // menu_title: "Advance Payment",
            // sub_menu: [
            // 	{
            menu_url: "/customer-list",
            menu_title: "Advance Received",
            menu_name: "advanced_received",
            sub_menu: [],
            // },
            // {
            // 	menu_url: "/assign-advance-payment",
            // 	menu_title: "Assign Advance Payment",

            // },
            // ],
          },

          {
            item_id: "422",
            menu_url: "/invoice-list",
            menu_title: "Receive Payment",
            menu_name: "receive_payment",
            // menu_title: "Pay Invoice",
            sub_menu: [],
          },
          {
            item_id: "423",
            menu_url: "/job-list-retailer",
            menu_title: "Pay Out Retailer",
            menu_name: "payout_retailer",
            sub_menu: [],
          },
          {
            item_id: "424",
            menu_url: "/credit-note-list",
            menu_title: "Credit Note",
            menu_name: "credit_note",
            sub_menu: [],
          },
          {
            item_id: "425",
            menu_url: "/financially-closed-job-list",
            menu_title: "Financially Closed",
            menu_name: "financially_closed",
            sub_menu: [],
          },
        ],
      },
      {
        item_id: "43",
        menu_url: "",
        menu_title: "Reports",
        menu_name: "reports",
        sub_menu: [
          {
            item_id: "431",
            menu_url: "/performance",
            menu_title: "Performance",
            menu_name: "performance",
            sub_menu: [],
          },
          {
            item_id: "432",
            menu_url: "/shipment",
            menu_title: "Shipment Wise Performance",
            menu_name: "shipment_wise_performance",
            sub_menu: [],
          },
          {
            item_id: "433",
            menu_url: "/add-ons",
            menu_title: "Add Ons",
            menu_name: "add_ons",
            sub_menu: [],
          },
          {
            item_id: "434",
            menu_url: "/retailer-performance",
            menu_title: "Retailer/Customer Wise Performance",
            menu_name: "retailer/Customer_wise_performance",
            sub_menu: [],
          },
          {
            item_id: "435",
            menu_url: "/retailer-incentive",
            menu_title: "Retailer Incentive",
            menu_name: "retailer_incentive",
            sub_menu: [],
          },
          {
            item_id: "436",
            menu_url: "/vendors",
            menu_title: "Vendor",
            menu_name: "vendor",
            sub_menu: [],
          },

          {
            item_id: "437",
            menu_url: "/retailer-purchase-invoice",
            menu_title: "Retailer Purchase Invoice Value",
            menu_name: "retailer_purchase_inv_value",
            sub_menu: [],
          },
          {
            item_id: "440",
            menu_url: "/invoice-report",
            menu_title: "Invoice Report",
            menu_name: "invoice_report",
            sub_menu: [],
          },
          {
            item_id: "438",
            menu_url: "/customer-service",
            menu_title: "Customer Service",
            menu_name: "customer_service",
            sub_menu: [],
          },
          {
            item_id: "439",
            menu_url: "/sales-tele",
            menu_title: "Sales/Tele Report",
            menu_name: "sales/tele_report",
            sub_menu: [],
          },
          {
            item_id: "43a",
            menu_url: "/tracking-report",
            menu_title: "Tracking Report",
            menu_name: "/tracking_report",
            sub_menu: [],
          },
          {
            item_id: "43b",
            menu_url: "/financial-job-report",
            menu_title: "Financial Job Report",
            menu_name: "Financial_Job_Report",
            sub_menu: [],
          },
          {
            item_id: "43c",
            menu_url: "/customer-report",
            menu_title: "Customer Report",
            menu_name: "customer_Report",
            sub_menu: [],
          },
        ],
      },
      {
        item_id: "44",
        menu_url: "/pick-up-list",
        menu_title: "Pickup Scheduler",
        menu_name: "pick_up_scheduler",
        sub_menu: [],
      },
      {
        item_id: "45",
        menu_url: "/tracking-list",
        menu_title: "Tracking",
        menu_name: "tracking",
        sub_menu: [],
      },
       {
        item_id: "45",
        menu_url: "/pickup-tracking-list", // route
        menu_title: "PickUp Tracking", // sidebar name
        menu_name: "pickup_tracking_list",
        sub_menu: [],
      },
      // {
      // 	menu_url: "/warehouse-update", // 11
      // 	menu_title: "Warehouse Updates",
      // 	sub_menu: [],
      // },
      {
        item_id: "46",
        menu_url: "/telr-payment-list",
        menu_title: "Online Transaction",
        menu_name: "online_transaction",
        sub_menu: [],
      },
      // {
      // 	menu_url: "/invoices-list",
      // 	menu_title: "Invoice",
      // 	sub_menu: [],
      // },
    ],
  },
  {
    item_id: "6",
    menu_title: "Web Link",
    menu_url: "",
    menu_name: "weblink",
    menu_icone: () => <MdOutlineCategory />,
    sub_menu: [
      {
        item_id: "61",
        menu_url: "category-list",
        menu_title: "Category",
        menu_name: "category",
        sub_menu: [],
      },
      {
        item_id: "62",
        menu_url: "sub-category-list",
        menu_title: "Sub Category",
        menu_name: "sub_category",
        sub_menu: [],
      },
      {
        item_id: "63",
        menu_url: "Web-Link-Retailer-List",
        menu_title: "Web Link Retailer",
        menu_name: "web_link_retailer",
        sub_menu: [],
      },
      {
        item_id: "64",
        menu_url: "Enquiry-List",
        menu_title: "Enquiry",
        menu_name: "weblink_enquiry",
        sub_menu: [],
      },
    ],
  },
  {
    item_id: "8",
    menu_title: "Sub Admin",
    menu_url: "/sub-admin-list",
    menu_icone: () => <RiAdminLine />,
    menu_name: false,
    sub_menu: [],
  },
  {
    item_id: "9",
    menu_title: "Gallery",
    menu_url: "/gallery",
    menu_icone: () => <RiGalleryLine />,
    menu_name: "gallery",
    sub_menu: [],
  },
  {
    item_id: "a",
    menu_title: "Blog",
    menu_url: "/blog-list",
    menu_icone: () => <RiBloggerLine />,
    menu_name: "blogs",
    sub_menu: [],
  },
  {
    item_id: "b",
    menu_title: "Calculator",
    menu_url: "",
    menu_name: "calculator",
    menu_icone: () => <MdOutlineCategory />,
    sub_menu: [
      {
        item_id: "b1",
        menu_url: "wooden-box-calculator",
        menu_title: "Wooden Box",
        menu_name: "wooden_box_calculator",
        sub_menu: [],
      },
      {
        item_id: "b2",
        menu_url: "insurance-calculator",
        menu_title: "Insurance",
        menu_name: "insurance_calculator",
        sub_menu: [],
      },
      {
        item_id: "b3",
        menu_url: "duty-and-tax-calculator",
        menu_title: "Duty & Tax",
        menu_name: "duty_and_tax_calculator",
        sub_menu: [],
      },
    ],
  },
];

export const SideBar = () => {
  const [li_value1, set_li_value1] = useState("key");
  const [li_value2, set_li_value2] = useState("key");
  const [li_value3, set_li_value3] = useState("key");
  const [li_value4, set_li_value4] = useState("key");
  const [access, setAccess] = useState([]);
  const [isRetailer, setIsRetailer] = useState(false);

  // const [menuItem, setMenuItem] = useState(Storage.get('getMenu') ? Storage.get('getMenu') : [])
  const [menuItem, setMenuItem] = useState(sidebarmenu);
  const [queryUnread, setQueryUnread] = useState(0);
  const history = useHistory();

  useEffect(() => {
    let profileData = Storage.get("auth");
    if (profileData?.admin_type && profileData?.admin_type === "SUPERADMIN") {
      setAccess(profileData?.admin_type);
    } else if (profileData?.role) {
      if (profileData.role.toLowerCase() === "retailer" || profileData.type?.toLowerCase() === "retailer") {
        setIsRetailer(true);
      }
      setAccess(profileData.access);
    } else if (profileData?.type && profileData.type.toLowerCase() === "retailer") {
      setIsRetailer(true);
    }
    const loadQueryCount = () => {
      PlanService.getQueryNotifications().then((res) => {
        if (res && res.status) setQueryUnread(Number(res.unread) || 0);
      }).catch(() => {});
    };
    loadQueryCount();
    const timer = setInterval(loadQueryCount, 30000);
    window.addEventListener('plan-queries-read', loadQueryCount);
    menuService.getMenu().then((res) => {
      if (res && res.status) {
        // setMenuItem(res.data)
        Storage.set("getMenu", res.data);
      } else {
        if (res && res.response_status === 401) {
          Storage.remove("auth");
          history.push("/admin");
        }
      }
    });
    return () => {
      clearInterval(timer);
      window.removeEventListener('plan-queries-read', loadQueryCount);
    };
  }, []);

  // const findAccess = (parent, child, subchild) => {
  //   let data = null;
  //   if (subchild) {
  //     Array.isArray(access) &&
  //       access.length > 0 &&
  //       access.find((item) => {
  //         if (item.value === parent) {
  //           item.sub_item.find((item2) => {
  //             if (item2.value === child) {
  //               let newdata =
  //                 (item2?.sub_item &&
  //                   item2.sub_item.find((item3) => item3.value === subchild)) ||
  //                 "";
  //               data = newdata;
  //             }
  //           });
  //         }
  //       });
  //   } else if (child) {
  //     Array.isArray(access) &&
  //       access.length > 0 &&
  //       access.find((item) => {
  //         if (item.value === parent) {
  //           let newdata =
  //             (item?.sub_item &&
  //               item.sub_item.find((item2) => item2.value === child)) ||
  //             "";
  //           data = newdata;
  //         }
  //       });
  //   } else if (Array.isArray(access) && access.length > 0) {
  //     data = access.find((item) => item.value === parent);
  //   }
  //   // console.log(data,'data')
  //   return data?.value || false;
  // };

  const findAccessItm = (id, index) => {
    if (id !== undefined) {
      if (access) {
        let length = index + 1;
        let findId = access.find((e) => {
          let trimInd = e.item_id.toString().slice(0, length);
          let trimId = id.toString().slice(0, length);
          return trimInd == trimId;
        })
          ? true
          : false;

        return findId;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };


  return (
    <div className="vertical-menu">
      {/* LOGO */}
      <div className="navbar-brand-box">
        <a href="index.html" className="logo logo-dark">
          <span className="logo-sm">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="" height={18} />
          </span>
          <span className="logo-lg">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="" height={45} />
          </span>
        </a>
        <a href="index.html" className="logo logo-light">
          <span className="logo-sm">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="" height={18} />
          </span>
          <span className="logo-lg">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="" height={45} />
          </span>
        </a>
      </div>
      <div data-simplebar className="sidebar-menu-scroll">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {menuItem.length > 0 &&
              menuItem.map((item, key) => {
                const isMyBookings = item.menu_name === "my_bookings";
                const canSeeMenu = access === "SUPERADMIN" || item.menu_name === true || findAccessItm(item.item_id, 0);
                
                if ((isMyBookings && isRetailer) || (!isMyBookings && canSeeMenu)) {
                  return (
                    <li
                      className={li_value1 === key ? "mm-active" : ""}
                      key={key + Math.random().toString()}
                    >
                      <a
                        onClick={() =>
                          item.sub_menu.length > 0
                            ? set_li_value1((value) =>
                                value === key ? "key" : key
                              )
                            : (history.push(item.menu_url),
                              set_li_value1((value) =>
                                value === key ? "key" : key
                              ))
                        }
                        className={
                          item.sub_menu.length > 0
                            ? "has-arrow waves-effect"
                            : "waves-effect"
                        }
                        aria-expanded="false"
                      >
                        {item.menu_icone()}
                        <span>{item.menu_title}</span>
                        {item.menu_url === "/plan-list" && queryUnread > 0 && (
                          <span className="badge bg-danger rounded-pill ms-2">{queryUnread}</span>
                        )}
                      </a>

                      {item.sub_menu.length > 0 &&
                        item.sub_menu.map((subMenu, key1) => {
                          if (
                            access === "SUPERADMIN" ||
                            subMenu.menu_name === true ||
                            findAccessItm(subMenu.item_id, 1)
                          ) {
                            return (
                              <ul
                                key={key1 + Math.random().toString()}
                                className={
                                  li_value1 === key
                                    ? "sub-menu mm-collapse mm-show"
                                    : "sub-menu mm-collapse"
                                }
                                aria-expanded="true"
                              >
                                {subMenu.sub_menu.length > 0 ? (
                                  <li
                                    className={
                                      li_value2 === key1 ? "mm-active" : ""
                                    }
                                  >
                                    <a
                                      onClick={() =>
                                        set_li_value2((value) =>
                                          value === key1 ? "key" : key1
                                        )
                                      }
                                      className="has-arrow pointer"
                                      aria-expanded="false"
                                    >
                                      {subMenu.menu_title}
                                    </a>
                                    {subMenu.sub_menu.length > 0 &&
                                      subMenu.sub_menu.map((endMenu, key2) => {
                                        if (
                                          access === "SUPERADMIN" ||
                                          findAccessItm(endMenu.item_id, 2)
                                        ) {
                                          return (
                                            <ul
                                              key={
                                                key2 + Math.random().toString()
                                              }
                                              className={
                                                li_value2 === key1
                                                  ? "sub-menu1 mm-collapse mm-show"
                                                  : "sub-menu1 mm-collapse"
                                              }
                                              aria-expanded="true"
                                            >
                                              {endMenu.sub_menu.length > 0 ? (
                                                <li
                                                  className={
                                                    li_value3 === key2
                                                      ? "mm-active"
                                                      : ""
                                                  }
                                                >
                                                  <a
                                                    onClick={() =>
                                                      set_li_value3((value) =>
                                                        value === key2
                                                          ? "key"
                                                          : key2
                                                      )
                                                    }
                                                    className="has-arrow pointer"
                                                    aria-expanded="false"
                                                  >
                                                    {endMenu.menu_title}
                                                  </a>
                                                  <ul
                                                    className={
                                                      li_value3 === key2
                                                        ? "sub-menu2 mm-collapse mm-show"
                                                        : "sub-menu2 mm-collapse"
                                                    }
                                                    aria-expanded="true"
                                                  >
                                                    {endMenu.sub_menu.length >=
                                                      1 &&
                                                      endMenu.sub_menu.map(
                                                        (endMenu1, key3) => (
                                                          <li
                                                            className={
                                                              li_value4 ===
                                                              endMenu1.menu_title
                                                                ? "mm-active"
                                                                : ""
                                                            }
                                                            key={
                                                              key3 +
                                                              Math.random().toString()
                                                            }
                                                            onClick={() =>
                                                              set_li_value4(
                                                                (value) =>
                                                                  value ===
                                                                  endMenu1.menu_title
                                                                    ? "key"
                                                                    : endMenu1.menu_title
                                                              )
                                                            }
                                                          >
                                                            <Link
                                                              to={
                                                                endMenu1.menu_url
                                                              }
                                                            >
                                                              {
                                                                endMenu1.menu_title
                                                              }
                                                            </Link>
                                                          </li>
                                                        )
                                                      )}
                                                  </ul>
                                                </li>
                                              ) : (
                                                <>
                                                  {Boolean(
                                                    endMenu.menu_title != ""
                                                  ) && (
                                                    <li
                                                      className={
                                                        li_value3 === key2
                                                          ? "mm-active"
                                                          : ""
                                                      }
                                                      onClick={() => {
                                                        set_li_value3((value) =>
                                                          value === key2
                                                            ? "key"
                                                            : key2
                                                        );
                                                        history.push(
                                                          endMenu.menu_url
                                                        );
                                                      }}
                                                    >
                                                      <Link to={`#`}>
                                                        {endMenu.menu_title}
                                                      </Link>
                                                    </li>
                                                  )}
                                                </>
                                              )}
                                            </ul>
                                          );
                                        }
                                      })}
                                  </li>
                                ) : (
                                  <li
                                    className={
                                      li_value2 === key1 ? "mm-active" : ""
                                    }
                                    onClick={() => {
                                      set_li_value2((value) =>
                                        value === key1 ? "key" : key1
                                      );
                                      history.push(subMenu.menu_url);
                                    }}
                                  >
                                    <Link to={subMenu.menu_url}>
                                      {subMenu.menu_title}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            );
                          }
                        })}
                    </li>
                  );
                }
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default SideBar;
